import { render, staticRenderFns } from "./NewsListItem.vue?vue&type=template&id=035191b0&scoped=true"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"
import style0 from "./NewsListItem.vue?vue&type=style&index=0&id=035191b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035191b0",
  null
  
)

export default component.exports